import React, { useState } from 'react'
import { Form, InputGroup, Col, Button, Accordion, Card, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from "@hookform/error-message";
import { dateToStringEN, dateToString } from '../../../utils';

const AddDestinoLaico = ({ setSelected, selected, provincias, handleForm, edicion = {} }) => {

  const { register, formState: { errors }, handleSubmit, watch } = useForm({
    defaultValues: {
      startDate: edicion.startDate ? edicion.startDate : null,
      endDate: edicion.endDate ? edicion.endDate : null,
      provinceId: edicion.provinceId ? edicion.provinceId : null,
      id: edicion.id ? edicion.id : null
      },
    })

  const onSubmit = (data) => {
    if(data.endDate === ''){
      //delete data.endDate
      delete data.endDate
    }
    //si no recupero los datos es POST si no es PUT
    handleForm(data, edicion && edicion.id ? false : true);
    //console.log( edicion && edicion.id === {})
    //console.log(edicion)
  };

  return (
    <>
    <small>(Nota: Si hay varios destinos insértelos cronológicamente)</small>
      <Form onSubmit={handleSubmit(onSubmit)} className="rounded p-4" >
        <Form.Row>
          <Form.Group as={Col} xs={12} md>
            <InputGroup className="mr-3">

              <InputGroup className="mt-2">
                <InputGroup.Prepend>
                  <InputGroup.Text>{"Fecha inicio"}</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="date"
                  {...register("startDate", {
                    required: "Este campo es obligatorio"
                    ,validate: {
                      dateMayorHaceMilDias: (date) => {
                        let thousandDaysAgo = new Date();
                        thousandDaysAgo.setDate(thousandDaysAgo.getDate() - 1000);
                        //console.log(thousandDaysAgo)
                        let inAThousandDays = new Date();
                        inAThousandDays.setDate(thousandDaysAgo.getDate() + 1000);
                        return watch("startDate") > dateToStringEN(thousandDaysAgo) ? watch("startDate") < dateToStringEN(inAThousandDays) ? true : `La fecha de inicio debe ser inferior a ${dateToString(inAThousandDays)}` : `La fecha de inicio debe ser superior a ${dateToString(thousandDaysAgo)}`
                      },
                    
                    },
                  }

                  )}
                />
              </InputGroup>
              <small><ErrorMessage errors={errors} name="startDate" /></small>

              <InputGroup className="mt-2">
                <InputGroup.Prepend>
                  <InputGroup.Text>{"Fecha fin"}</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="date"
                  {...register("endDate", {
                    validate: {
                      dateMenorQueEndDate: (date) => {
                        if (watch("endDate")<= watch("startDate")) return new Date(watch("endDate")) > new Date(date) ? true : "La fecha de inicio debe ser menor a la fecha de fin";
                      },
                    }
                  })}
                />
              </InputGroup>
              <small><ErrorMessage errors={errors} name="endDate" /></small>

              <InputGroup className="mt-2">
                <InputGroup.Prepend >
                  <InputGroup.Text >{"Provincia"}</InputGroup.Text>
                </InputGroup.Prepend>

                <Form.Control as="select" {...register("provinceId", { required: "Este campo es obligatorio" })} custom>
                  <option value=""> - Seleccione una provincia -</option>
                  {provincias.items?.length ? provincias?.items.map(provincia => {
                    return (
                      <option key={provincia.id} value={provincia.id}>
                        {`${provincia.name}`}
                      </option>
                    );
                  })
                    :
                    "No hay cursos en alta"}
                </Form.Control>

              </InputGroup>
              <small><ErrorMessage errors={errors} name="provinceId" /></small>

            </InputGroup>
          </Form.Group>
        </Form.Row>

        <Button type='submit' className='button-outline-primary' variant="outline-primary">Guardar</Button>
      </Form>
    </>

  )
}
export default AddDestinoLaico